import clsx from 'clsx';
import type * as React from 'react';

import type { IntegrationBlock } from '@gitbook/api-client';
import { Image, sizes } from '@gitbook/react-uikit';
import { Icon } from '@gitbook/spine-icons';

import { getImageResizedURL } from '../../utils';

/**
 * Icon for an integration's block.
 */
export function IntegrationBlockIcon(props: {
    block: IntegrationBlock;
    size?: number;
    className?: string;
}): React.ReactElement {
    const { block, className, size = sizes.ICON_400 } = props;

    if (!block.icon) {
        return <Icon.Integrations className={clsx('size-4.5', className)} />;
    }

    return (
        <Image
            source={{ uri: getImageResizedURL(block.icon, { width: size }) }}
            style={[
                {
                    width: size,
                    height: size,
                    borderRadius: size / 8,
                },
            ]}
        />
    );
}
